import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import styles from './style.module.scss';
const AlertPanel = ({ icon, title, size = 'large', message }) => {
    return (_jsx("main", { className: styles.alertPanel, children: _jsxs("div", { className: clsx(styles.alert, size === 'small' && styles.smallAlert), children: [_jsx("div", { className: styles[`${size}Icon`], children: icon }), _jsxs("div", { children: [_jsx("h2", { children: title }), message !== undefined && _jsx("p", { children: message })] })] }) }));
};
export default AlertPanel;
